'use client';
import { ProductStockStatus, useCompetitorService, useRegionCurrency } from '@skin-seoul/service';
import { useProductService, useReviewService, getLowestPriceProductBasicInfo } from '@skin-seoul/service';
import React, { useMemo } from 'react';
import { createReviewStatsMap } from '@skin-seoul/service';
import { createCompetitorProductMap } from '@skin-seoul/service';
import PriceOnAmazon from './components/PriceOnAmazon';
import { GridItem } from '@skin-seoul/design-system';
import { VerticalProductCard } from '../../components/ProductCard';

const ALLOWED_CURRENCY = ['USD', 'AUD', 'GBP', 'CAD'];

const AmazonProductList = () => {
  const { useGetProductsCollectionCompetitor } = useProductService();
  const { useGetReviewStatistics } = useReviewService();
  const { useGetCompetitorMatchedProducts } = useCompetitorService();
  const { currency } = useRegionCurrency();

  const { data } = useGetProductsCollectionCompetitor({
    collectionName: 'GGU Amazon Bestseller',
    competitorName: 'Amazon',
    currency: currency,
    stockStatus: ProductStockStatus.instock,
  });

  const products = useMemo(() => {
    return (data?.products?.length ? data.products : []).slice(0, 5);
  }, [data]);

  const { data: reviewStats } = useGetReviewStatistics({
    productIds: products.map((product) => product.productId).join(','),
  });

  const reviewStatsMap = useMemo(() => createReviewStatsMap(reviewStats?.statistics), [reviewStats]);

  const { data: competitorData } = useGetCompetitorMatchedProducts({
    skus: products.map((product) => getLowestPriceProductBasicInfo(product).sku),
    enabled: ALLOWED_CURRENCY.includes(currency),
  });

  const competitorProductsMap = useMemo(
    () => createCompetitorProductMap(competitorData, 'Amazon', currency),
    [competitorData, currency],
  );
  return (
    <React.Fragment>
      {products.map((product) => {
        const productInfo = getLowestPriceProductBasicInfo(product);
        const productReviewStats = reviewStatsMap[productInfo.productId];
        const competitorProduct = competitorProductsMap[productInfo.sku];

        return (
          <GridItem key={productInfo.productId + 'amazon-product-list'}>
            <VerticalProductCard
              key={productInfo.productId}
              name={productInfo.name}
              brand={productInfo.brand}
              productImage={productInfo.productImageUrls[0] || ''}
              sku={productInfo.sku}
              currency={productInfo.currency}
              originalPrice={productInfo.originalPrice}
              salePrice={productInfo.salePrice}
              rating={productReviewStats?.averageRate}
              reviewCount={productReviewStats?.totalReviews}
              onClick={() => window.open(product.productLink, '_blank')}
              theme="dark"
            >
              <VerticalProductCard.Image
                topSlot={<VerticalProductCard.DiscountBadge backgroundColor="#0578FF" />}
                bottomSlot={
                  <PriceOnAmazon price={competitorProduct?.price.salesPrice} currency={productInfo.currency} />
                }
              />
              <VerticalProductCard.Content>
                <VerticalProductCard.InfoName />
                <VerticalProductCard.InfoRating />
                <VerticalProductCard.InfoPrice />
              </VerticalProductCard.Content>
            </VerticalProductCard>
          </GridItem>
        );
      })}
    </React.Fragment>
  );
};

export default AmazonProductList;
